import { BaseService } from "./BaseService";

export class SearchService extends BaseService {
  getSavedSearchPrograms(top) {
    return this.request(`api/Search/GetSavedSearchPrograms/${top !== undefined && top !== null ? top : ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getHomepageSavedSearches() {
    return this.request(`api/Search/GetHomepageSavedSearches`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getFavoritesSavedSearches() {
    return this.request(`api/Search/GetFavoritesSavedSearches`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getAdvancedSearchPrograms(filter) {
    return this.request("api/Search/GetAdvancedSearchPrograms", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getAdvancedSearchProgramsExport(filter) {
    return this.request(`api/Search/GetAdvancedSearchProgramsExport`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getMinMaxDatesbyPrograms(filter) {
    return this.request(`api/Search/GetMinMaxDatesbyPrograms`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getCountriesByPrograms(filter) {
    return this.request(`api/Search/GetCountriesByPrograms`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getCountriesDevelopedIn(filter) {
    return this.request(`api/Search/GetCountriesDevelopedIn`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getCountriesProducedIn(filter) {
    return this.request(`api/Search/GetCountriesProducedIn`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getGenres(filter) {
    return this.request(`api/Search/GetGenres`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getKeywords(filter) {
    return this.request(`api/Search/GetKeywords`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getFrequencies(filter) {
    return this.request(`api/Search/GetFrequencies`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getPlatforms(filter) {
    return this.request(`api/Search/GetPlatforms`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getSavedSearches() {
    return this.request("api/Search/GetSavedSearches", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getDailyUpdateSavedSearches() {
    return this.request("api/Search/GetDailyUpdateSavedSearches", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  createSearch(search) {
    return this.request("api/Search/CreateSearch", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(search),
    });
  }

  saveSearchFilter(search) {
    return this.request("api/Search/SaveSearchFilter", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(search),
    });
  }

  saveSearch(search) {
    return this.request("api/Search/SaveSearch", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(search),
    });
  }

  saveSortableSearch(search) {
    return this.request("api/Search/SaveSortableSearch", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(search),
    });
  }

  duplicateSearch(id) {
    return this.request(`api/Search/DuplicateSearch/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
    });
  }

  deleteSearch(id) {
    return this.request(`api/Search/DeleteSearch/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
    });
  }

  addSearchFolder(searchFolder) {
    return this.request("api/Search/AddSearchFolder", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(searchFolder),
    });
  }

  saveSearchFolder(searchFolder) {
    return this.request("api/Search/SaveSearchFolder", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(searchFolder),
    });
  }

  deleteSearchFolder(id) {
    return this.request(`api/Search/DeleteSearchFolder/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
    });
  }

  getSortableSearches() {
    return this.request("api/Search/GetSortableSearches", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  setSortableSearches(sortableList) {
    return this.request("api/Search/SetSortableSearches", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(sortableList),
    });
  }

  setSearchShowInHomepage(idSearches) {
    return this.request(`api/Search/SetSearchShowInHomepage`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(idSearches),
    });
  }

  setSearchFavorites(idSearches) {
    return this.request(`api/Search/SetSearchFavorites`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(idSearches),
    });
  }

  setSearchDailyUpdate(idSearch, state) {
    return this.request(`api/Search/SetSearchDailyUpdate/${idSearch}/${state}/`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
    });
  }
}

const searchService = new SearchService();

export default searchService;
